// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7077) return "static/chunks/7077-ac589ddffa84a1b4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2360":"2cdb27228d865acf","2615":"98db9d53cb36b8de"}[chunkId] + ".js";
};